module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Modal', {
    staticClass: "address-modal",
    attrs: {
      "width": "550"
    },
    on: {
      "on-cancel": _vm.cancel
    },
    model: {
      value: (_vm.isShow),
      callback: function($$v) {
        _vm.isShow = $$v
      },
      expression: "isShow"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#3280bf",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("新增收货人地址")])]), _vm._v(" "), _c('div', [_c('Form', {
    staticStyle: {
      "background-color": "#fff",
      "padding-bottom": "20px"
    },
    attrs: {
      "model": _vm.addForm,
      "label-width": 120
    }
  }, [_c('FormItem', {
    staticClass: "must",
    attrs: {
      "label": "姓名"
    }
  }, [_c('Input', {
    staticClass: "form-input",
    model: {
      value: (_vm.addForm.consigneeName),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "consigneeName", $$v)
      },
      expression: "addForm.consigneeName"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "padding-left": "15px"
    }
  }, [_vm._v("请填写真实姓名，以免延误收货")])], 1), _vm._v(" "), _c('FormItem', {
    staticClass: "must",
    attrs: {
      "label": "手机"
    }
  }, [_c('Input', {
    staticClass: "form-input",
    model: {
      value: (_vm.addForm.mobile),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "mobile", $$v)
      },
      expression: "addForm.mobile"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "电话"
    }
  }, [_c('Input', {
    staticClass: "form-input",
    model: {
      value: (_vm.addForm.telephone),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "telephone", $$v)
      },
      expression: "addForm.telephone"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "padding-left": "15px"
    }
  }, [_vm._v("手机和电话填写一项即可")])], 1), _vm._v(" "), _c('FormItem', {
    staticClass: "must",
    attrs: {
      "label": "地区"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "size": "small",
      "placeholder": "请选择省份"
    },
    on: {
      "on-change": _vm.getCityList
    },
    model: {
      value: (_vm.addForm.provinceId),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "provinceId", $$v)
      },
      expression: "addForm.provinceId"
    }
  }, _vm._l((_vm.provinceList), function(item) {
    return _c('Option', {
      key: item.regionId,
      attrs: {
        "value": item.regionId
      }
    }, [_vm._v(_vm._s(item.localName) + "\n            ")])
  }), 1), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "size": "small"
    },
    on: {
      "on-change": _vm.getRegionList
    },
    model: {
      value: (_vm.addForm.cityId),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "cityId", $$v)
      },
      expression: "addForm.cityId"
    }
  }, _vm._l((_vm.cityList), function(item) {
    return _c('Option', {
      key: item.regionId,
      attrs: {
        "value": item.regionId
      }
    }, [_vm._v(_vm._s(item.localName) + "\n            ")])
  }), 1), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "size": "small"
    },
    on: {
      "on-change": _vm.getCountryList
    },
    model: {
      value: (_vm.addForm.regionId),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "regionId", $$v)
      },
      expression: "addForm.regionId"
    }
  }, _vm._l((_vm.regionList), function(item) {
    return _c('Option', {
      key: item.regionId,
      attrs: {
        "value": item.regionId
      }
    }, [_vm._v(_vm._s(item.localName) + "\n            ")])
  }), 1), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.addForm.countyId),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "countyId", $$v)
      },
      expression: "addForm.countyId"
    }
  }, _vm._l((_vm.countryList), function(item) {
    return _c('Option', {
      key: item.regionId,
      attrs: {
        "value": item.regionId
      }
    }, [_vm._v(_vm._s(item.localName) + "\n            ")])
  }), 1)], 1), _vm._v(" "), _c('FormItem', {
    staticClass: "must",
    attrs: {
      "label": "地址"
    }
  }, [_c('Input', {
    staticClass: "form-input",
    model: {
      value: (_vm.addForm.address),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "address", $$v)
      },
      expression: "addForm.address"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "邮编"
    }
  }, [_c('Input', {
    staticClass: "form-input",
    model: {
      value: (_vm.addForm.zipCode),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "zipCode", $$v)
      },
      expression: "addForm.zipCode"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "error",
      "size": "large",
      "long": ""
    },
    on: {
      "click": _vm.saveAddr
    }
  }, [_vm._v("保存并返回")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e114292"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/shopping-cart/addressModal.vue
// module id = 1632
// module chunks = 1